var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-wrap align-center justify-space-between mb-4",
          staticStyle: { gap: "10px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              staticStyle: { gap: "10px" }
            },
            [
              _vm.isLive
                ? _c(
                    "div",
                    {
                      staticClass:
                        "detail-tab-transcricao__live-badge text-color-100"
                    },
                    [
                      _c("span", {
                        staticClass: "detail-tab-transcricao__live-dot"
                      }),
                      _vm._v(" AO VIVO ")
                    ]
                  )
                : _vm._e(),
              _vm.isLive
                ? _c("span", { staticClass: "az-text-small" }, [
                    _vm._v(" Atualiza automaticamente a cada 10 segundos ")
                  ])
                : _vm._e()
            ]
          ),
          _vm.segments.length
            ? _c("input-by-type", {
                staticStyle: { width: "240px" },
                attrs: {
                  type: "search",
                  placeholder: "Buscar na transcrição…"
                },
                model: {
                  value: _vm.searchSegment,
                  callback: function($$v) {
                    _vm.searchSegment = $$v
                  },
                  expression: "searchSegment"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.segments.length && _vm.isSearchingSegments
        ? _c("p", { staticClass: "az-text-small mb-3" }, [
            _vm._v(
              " " +
                _vm._s(_vm.filteredSegments.length) +
                " de " +
                _vm._s(_vm.segments.length) +
                " trechos "
            )
          ])
        : _vm._e(),
      _vm.messages.length
        ? [
            _c(
              "div",
              { staticClass: "detail-tab-transcricao__card rounded-sm pa-4" },
              [
                _c(
                  "div",
                  { staticClass: "detail-tab-transcricao__chat" },
                  _vm._l(_vm.messages, function(msg) {
                    return _c(
                      "div",
                      {
                        key: msg.key,
                        staticClass: "detail-tab-transcricao__row"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "detail-tab-transcricao__time-col" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "az-text-small font-medium text-no-wrap"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatSegmentTime(msg.timestamp)
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _vm.segmentClock(msg.timestamp)
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-small text-no-wrap detail-tab-transcricao__clock"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.segmentClock(msg.timestamp)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "detail-tab-transcricao__avatar text-color-100"
                          },
                          [
                            msg.self && _vm.avatarUrl
                              ? _c("img", {
                                  staticClass:
                                    "detail-tab-transcricao__avatar-img",
                                  attrs: {
                                    src: _vm.avatarUrl,
                                    alt: _vm.getInitials(msg.speaker)
                                  }
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.getInitials(msg.speaker)))
                                ])
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "detail-tab-transcricao__content" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "az-text-small font-semibold primary--text"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(msg.speaker || "Desconhecido")
                                ),
                                msg.self ? [_vm._v(" · Você")] : _vm._e(),
                                _vm._v(": ")
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "detail-tab-transcricao__bubble" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "az-text-primary az-size-14 mb-0"
                                  },
                                  [_vm._v(_vm._s(msg.text))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ]
        : _c(
            "TranscriptStateFeedback",
            _vm._b({}, "TranscriptStateFeedback", _vm.emptyFeedback, false)
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }